import React from "react";

interface AppButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "primary" | "success" | "danger" | "warning" | "secondary";
  size?: "sm" | "md" | "lg";
  className?: string;
  type?: "button" | "submit";
}

const variantClasses: Record<string, string> = {
  primary: "bg-primary text-white hover:opacity-90",
  success: "bg-success text-white hover:opacity-90",
  danger: "bg-danger text-white hover:opacity-90",
  warning: "bg-warning text-white hover:opacity-90",
  secondary: "bg-secondary text-white hover:opacity-90",
};

const sizeClasses: Record<string, string> = {
  sm: "px-3 py-1 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-5 py-3 text-lg",
};

const AppButton: React.FC<AppButtonProps> = ({
  children,
  onClick,
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`
        rounded-pill shadow-sm d-inline-flex align-items-center gap-2
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${className}
      `}
      style={{ transition: "all 0.2s ease" }}
    >
      {children}
    </button>
  );
};

export default AppButton;
